const products = [
  {
    id: 1,
    name: "AI Course",
    new_price: 50,
    category: "ai",
    image: "https://via.placeholder.com/150"
  },
  {
    id: 2,
    name: "Tech Course",
    new_price: 80,
    category: "tech",
    image: "https://via.placeholder.com/150"
  },
];

export default products;